import React from "react";
import { Box } from "arkh";

export function OrgUserRolesRow(props: {
  access: React.ReactNode;
  role: React.ReactNode;
  action: React.ReactNode;
}) {
  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <Box
        style={{
          flex: 3,
        }}
        spaceRight="large"
      >
        {props.access}
      </Box>
      <Box
        style={{
          flex: 3,
        }}
        spaceRight="large"
      >
        {props.role}
      </Box>
      <Box
        style={{
          alignItems: "flex-end",
          flex: 1,
        }}
      >
        {props.action}
      </Box>
    </Box>
  );
}
